import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(
  theme => ({
    container: {
      backgroundColor: 'transparent !important',
      width: '100%',
      zIndex: 3
    },
    root: {
      display: 'flex'
    },
    paper: {
      marginRight: theme.spacing(2)
    },
    button: {
      textTransform: 'none',
      fontFamily: 'Work Sans'
    },
    buttonBlack: {
      backgroundColor: 'black !important',
      borderRadius: 30,
      color: 'white !important',
      marginRight: 5,
      paddingBottom: 10,
      paddingInline: 5,
      paddingTop: 10,
      textTransform: 'none',
      width: '8rem'
    },
    buttonWhite: {
      backgroundColor: 'transparent',
      borderRadius: 30,
      color: 'black',
      paddingBottom: 10,
      paddingTop: 10,
      textTransform: 'none',
      width: '8rem'
    },
    sideMenu: {
      minWidth: 50,
      maxWidth: 500
    },
    sideMenuCollapseButton: {
      display: 'flex !important',
      justifyContent: 'space-between !important',
      width: '100% !important'
    },
    sideMenuItem: {
      borderTop: '1px solid #D2D2D2 !important',
      width: '100% !important'
    },
    sideMenuText: {
      fontFamily: "'Work Sans' !important",
      fontSize: '13px !important',
      fontStyle: 'normal',
      fontWeight: 400,
      letterSpacing: -0.1,
      lineHeight: '140%'
    }
  }),
  { classNamePrefix: 'Navbar' }
)
